import React from 'react';
import { CalendarDays, UserRound, Building2, MessageCircle, Mail, Phone, Sparkles, Activity } from 'lucide-react';
import './CustomerWorkspaceTabs.css';

export const customerViews = [
  ['profile', 'Overview'], ['sales', 'Sales'], ['whatsapp', 'WhatsApp'],
  ['email', 'Email'], ['meetings', 'Meetings'], ['calls', 'Calls'], ['ai', 'AI'], ['activity', 'Activity'],
];

const viewIcons = { meetings: CalendarDays, profile: UserRound, sales: Building2, whatsapp: MessageCircle, email: Mail, calls: Phone, ai: Sparkles, activity: Activity };

/** Shared navigation; hosts supply authorized content, never credentials. */
export default function CustomerWorkspaceTabs({ value, onChange }) {
  return <nav className="customer-workspace-tabs" aria-label="Customer views">
    {customerViews.map(([key, label]) => { const Icon = viewIcons[key]; return <button key={key} type="button"
      aria-pressed={value === key} onClick={() => onChange(key)}>
      <Icon size={16} aria-hidden="true" /><span>{label}</span>{key === 'email' && <small>Beta</small>}
    </button>; })}
  </nav>;
}

export function CustomerChannelPreview({ channel }) {
  return <section className="customer-channel-preview" aria-label={`${channel} preview`}>
    <span>{channel === 'Email' ? 'Beta' : 'Planned'}</span><h3>{channel}</h3>
    <p>{channel === 'Email' ? 'Read received and sent Gmail messages and compose plain-text email in Auto Appy Mail. Your mailbox stays private to your signed-in account.' : 'Customer call history, recordings and transcripts will appear here once Calling is available and connected.'}</p>
    {channel === 'Email' ? <a href="https://autoappy.com/mail" target="_blank" rel="noopener noreferrer">Open Auto Appy Mail</a> : <p>No account is connected and no calls can be made from this preview.</p>}
  </section>;
}
